import {
  Group,
  GroupFilter,
} from "@/components/pages_logged_in/certifications/GroupFilter";
import { SearchInput } from "@/components/ui/search-input";

import { IssueManuallyDialog } from "./IssueManuallyDialog";

export function CertificationParticipantsControls({
  search,
  onSearchChange,
  searching,
  availableGroups,
  selectedGroupIds,
  onSelectedGroupIdsChange,
  workspaceId,
  onIssueManually,
}: {
  search: string;
  onSearchChange: (search: string) => void;
  searching: boolean;
  availableGroups: Group[];
  selectedGroupIds: string[];
  onSelectedGroupIdsChange: (groupIds: string[]) => void;
  workspaceId?: string;
  onIssueManually: (
    userIds: string[],
    sendNotifications: boolean,
    onClose: (error?: string) => void,
    note?: string,
  ) => void;
}) {
  return (
    <div className="flex gap-2 justify-between flex-wrap">
      <div className=" w-full sm:w-2xs xl:w-xl">
        <SearchInput
          value={search}
          onChange={onSearchChange}
          loading={searching}
          placeholder="Search by name"
        />
      </div>
      <div className="flex flex-1 items-center gap-2 justify-between sm:justify-end">
        <GroupFilter
          availableGroups={availableGroups}
          selectedGroupIds={selectedGroupIds}
          onSelectedGroupIdsChange={onSelectedGroupIdsChange}
        />
        <IssueManuallyDialog
          onIssueManually={onIssueManually}
          workspaceId={workspaceId}
        />
      </div>
    </div>
  );
}
